module.exports = __webpack_public_path__ + "images/quote-dots.0c3313e09a.svg";